var generateComponentTheme = function generateComponentTheme(_ref) {
  var breakpoints = _ref.breakpoints,
    colors = _ref.colors,
    spacing = _ref.spacing,
    typography = _ref.typography,
    borders = _ref.borders,
    transitions = _ref.transitions;
  return {
    contentCellBorderColor: colors.tiara,
    answerRowCellPadding: spacing.xSmall,
    answerRowCorrectBackgroundColor: colors.white,
    answerRowAnswerIconColor: colors.shamrock,
    answerRowCorrectTextFieldFontWeight: typography.fontWeightBold,
    answerRowCorrectBarBackgroundColor: colors.shamrock,
    answerIconFontSize: typography.fontSizeXSmall,
    answerIconColor: colors.ash,
    answerTextfieldFontWeight: typography.fontWeightNormal,
    respondentLinkColor: colors.ash,
    respondentLinkPresentColor: colors.electric,
    answerRatioPaddingLeft: spacing.small,
    barMinWidth: borders.widthSmall,
    barBackgroundColor: colors.licorice,
    phoneBreakPoint: "max-width: ".concat(breakpoints.medium),
    barTransition: "width ".concat(transitions.duration)
  };
};
export default generateComponentTheme;